import React from 'react';

const AnimatedDots: React.FC = () => (
  <span className="animated-dots" aria-hidden="true">
    <span className="animated-dot" />
    <span className="animated-dot" />
    <span className="animated-dot" />
  </span>
);

export default AnimatedDots;
